// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__s5pK8","buttons":"Footer_buttons__1bb7t"};